import { getAllReportTemplates } from "@custom/Apis/apis";

export const calculateAge = (birthDateString) => {
    const birthDate = new Date(birthDateString);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    const dayDifference = today.getDate() - birthDate.getDate();

    // If the birthdate hasn't occurred yet this year, subtract 1 from the age
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--;
    }

    return age;
}

export const formatDate = (dateStr) => {
    if (dateStr.length !== 8) {
      throw new Error("Invalid date string length");
    }
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    const day = dateStr.slice(6, 8);
    return `${year}-${month}-${day}`;
  }


export const getTemplatesInMoreActions = async (navigate) => {
  const response = await getAllReportTemplates({});

  if(response?.status !== 'SUCCESS'){
    return {};
  }

  const moreActions = response?.templateList?.map((template) => {
    return {
      label: template?.templateName,
      iconName: 'reporticon',
      onClick: () => {
        console.log('Template: ', template);
        navigate('/createReport', { state: {template, patDetails: {}} });
      }
    }
  });

  return moreActions;
}
